<template>
  <div class="app-main-content">
    <div class="details-view">
      <div style="height: 100%">
        <div style="display: flex;flex-wrap: nowrap;height: 100%;">
          <div class="section" style="width: 20%; background-color: #ffffff">
            <span
              style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
            >{{
              '.'
            }}</span>
            <div style="padding-left: 10px;padding-bottom: 5px"> {{ $t('CargoMsg.Cargo_ConfigExecuteCommands') }}</div>
            <cargo-ag-grid
              :column-defs="columnDefs"
              :row-data="rowData"
              :grid-options="gridOptions"
              style="width: 100%;"
            />
          </div>
          <div class="section" style="width: 20%;background-color: #ffffff">
            <el-form
              label-position="right"
              label-width="70px"
              style="height: 100%; padding-top: 20px"
            >
              <el-form-item :label="$t('CargoMsg.Cargo_SelectCommand')">
                <!-- <el-select v-model="command.commandName" style="width: 250px">
                  <el-option
                    v-for="(item,index) in SystemConstants.TASK_SCENARIO_LIST"
                    :key="index"
                    :label="language?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select> -->
                <!--  选择租户操作指令弹窗  -->
                <tenant-instruction-batch-lob-dialog
                  v-if="form.taskScenario === SystemConstants.TASK_SCENARIO_6.code"
                  :key="command.serialNumber"
                  input-width="100%"
                  :lobs="instructionsLobs"
                  :apply-auto-execute="true"
                  :value="command.commandName"
                  tag-field="platformInstructionCode"
                  :tenant-instructions="tenantInstructions"
                  style="width: 250px"
                  @change="p => tenantInstructionChange(p, command)"
                />
                <tenant-instruction-dialog
                  v-else
                  :key="command.serialNumber"
                  input-width="100%"
                  lob="FS"
                  :apply-auto-execute="true"
                  :value="command.commandName"
                  tag-field="platformInstructionCode"
                  :tenant-instructions="tenantInstructions"
                  style="width: 250px"
                  @change="p => tenantInstructionChange(p, command)"
                />
              </el-form-item>
              <el-form-item label=" " style="height: 100%" class="input-from">
                <el-input
                  v-model="command.dataScript"
                  style="width: 250px"
                  :filter-chars="false"
                  type="textarea"
                  :rows="20"
                  clearable
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section" style="width: 60%; height: 99%;background-color: #ffffff" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { DocumentManage } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { commandDetailFunc } from '@/api/sysAutoConfig/sysAutoConfig'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { AutomationCommand } from '@/class/model/sys/AutomationCommand'
import { AutomationConfig } from '@/class/model/sys/AutomationConfig'
import TenantInstructionDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstructionDialog'
import TenantInstructionBatchLobDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstructionBatchLobDialog'
import { queryAllTenantInstruction } from '@/api/sysManage/baseConfig/instruction'

export default {
  name: 'CommandSettings',
  components: { TenantInstructionDialog, TenantInstructionBatchLobDialog },
  props: {},
  data() {
    return {
      documentManage: new DocumentManage(),
      SystemConstants,
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_SerialNo'),
          field: 'serialNumber',
          width: 50
        }, {
          headerName: this.$t('CargoMsg.Cargo_CommandName'),
          field: 'name',
          width: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'name',
          width: 100,
          cellRenderer: params => {
            const onAdd = this.documentManage.getPath('onAdd')
            const onDel = this.documentManage.getPath('onDel')
            return `<div>
                        <a onclick="${onAdd}('')" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${onDel}('${params.data.uuid}','${params.data.serialNumber}')" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }
      ],
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: { CargoAgGridCommonInputEditor },
        onRowClicked: event => {
          this.command = event.data
        }
      },
      deleteUuids: [],
      form: new AutomationConfig().fillDefaultValue().getData(),
      command: new AutomationCommand().fillDefaultValue().getData(),
      tenantInstructions: []
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh'
    },
    instructionsLobs() {
      if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_6.code) {
        return [SystemConstants.SE.code, SystemConstants.SI.code, SystemConstants.AE.code]
      }
      return [SystemConstants.FS.code]
    }
  },
  created() {
    // 查询租户操作指令
    queryAllTenantInstruction({}).then(res => {
      this.tenantInstructions = res.data
    })
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onAdd', function() {
      context.onAdd()
    })
    this.documentManage.set('onDel', function(value, value2) {
      context.onDel(value, value2)
    })
  },
  methods: {
    async onShow(action, form, refresh = true) {
      this.$emit('refreshDone', 'commandSettings')
      if (!refresh) {
        return
      }
      this.clearData()
      if (form && form.uuid) {
        this.form = form
        // 加载场景
        this.loadData(form.uuid)
      } else {
        this.onAdd()
        this.command = this.rowData[0]
      }
    },
    loadData(uuid) {
      if (!uuid) {
        return
      }
      commandDetailFunc({ uuid: uuid }).then(res => {
        this.rowData = res.data
        if (!this.rowData || this.rowData.length === 0) {
          this.onAdd()
        }
        this.command = this.rowData[0]
        ColumnUtils.addSerialNumber(this.rowData)
      })
    },
    onAdd() {
      const newConfiguration = new AutomationCommand().fillDefaultValue().getData()
      newConfiguration.serialNumber = 0
      this.rowData.push(newConfiguration)
      ColumnUtils.addSerialNumber(this.rowData)
    },
    onDel(uuid, serialNumber) {
      if (uuid !== null) {
        if (!this.deleteUuids) {
          this.deleteUuids = []
        }
        this.deleteUuids.push(uuid)
      }
      const data = this.rowData.filter(item => item.serialNumber === Number(serialNumber))
      if (data && data.length > 0) {
        this.rowData.splice(serialNumber - 1, 1)
      }
      if (this.rowData.length === 0) {
        this.onAdd()
      } else {
        ColumnUtils.addSerialNumber(this.rowData)
      }
    },
    clearData() {
      this.deleteUuids = []
      this.rowData = []
    },
    async getSubmitData() {
      return {
        deleteCommandUuids: this.deleteUuids,
        commandDetails: this.rowData
      }
    },
    endTabHandler() {
      this.$emit('ruleTaskChange', { ... this.rowData })
    },
    // 选择租户操作指令
    tenantInstructionChange(data, command) {
      if (data) {
        command.commandName = data.platformInstructionCode
      } else {
        command.commandName = ''
      }
    }
  }
}
</script>
